import React, { useContext, useEffect, useState } from 'react';
import format from 'date-fns/format';

import useApi from 'common/useApi';
import UiContext from 'common/UiContext/UiContext';

import DataTable from 'components/DataTable';

import DataTablePagination from 'components/DataTablePagination';
import classNames from 'classnames';

const Repair = () => {
  const { addToast } = useContext(UiContext);
  const [page, setPage] = useState(1);
  const [pageWorker, setPageWorker] = useState(1);

  const {
    data: tickets,
    isError: isError,
    isLoading: isLoading,
    isFetching,
  } = useApi('getList', '/api/repair-tickets', { page });

  const {
    data: workers,
    isError: isErrorWorker,
    isLoading: isLoadingWorker,
    isFetching: isFetchingWorker,
  } = useApi('getList', '/api/repair-workers', { page: pageWorker });

  const headers = [
    'Request Date',
    'Ticket ID',
    'Parts Needing Repair',
    'Tracking Number',
  ];

  const headersWorker = [
    'Worker Name',
    'Parts In Repair',
    'Ticket ID',
    'Ticket Request Date',
    'Status',
  ];

  const ticketList = () => tickets?.results.map(({
    date_requested,
    id,
    parts_needing_repair_display,
    details_unidentified,
    details_multiple,
    shipper,
    tracking_number,
  }: {
    date_requested: string
    id: number,
    parts_needing_repair_display: string,
    details_unidentified: string,
    details_multiple: string,
    shipper: string,
    tracking_number: string,
  }) => [
    format(new Date(date_requested), 'yyyy-MM-dd HH:mm:ss'),
    `#${id}`,
    `${parts_needing_repair_display} `
    + `${details_unidentified ? `(${details_unidentified})` : ''} `
    + `${details_multiple ? `(${details_multiple})` : ''}`,
    (shipper || tracking_number) ? `${shipper}: ${tracking_number}` : '(add)',
  ]);

  const workerList = () => workers?.results.map(({
    worker_name,
    parts_in_repair,
    ticket,
    ticket_date_requested,
    status_display,
  }: {
    worker_name: string
    parts_in_repair: string,
    ticket: number,
    ticket_date_requested: string,
    status_display: string,
  }) => [
    worker_name,
    parts_in_repair,
    `#${ticket}`,
    format(new Date(ticket_date_requested), 'yyyy-MM-dd HH:mm:ss'),
    {
      entry: status_display,
      formatter: 'StatusBadge',
    },
  ]);


  useEffect(() => {
    if(isError || isErrorWorker){
        addToast!('Error loading data. Please, retry');
    }
  }, [isError, isErrorWorker]);

  return (
    <>
      <h3>Open Tickets</h3>
      <div
        className={classNames({
          box: true,
          isLoading: isLoading || isFetching,
          table: true,
        })}
      >
        <DataTable isLoading={isLoading || isFetching} headers={headers} content={ticketList() ?? []} />
        <DataTablePagination
          page={page}
          totalItems={tickets?.count ?? 0}
          setPage={setPage}
        />
      </div>
      <h3>Miner Repair</h3>
      <div
        className={classNames({
          box: true,
          isLoading: isLoadingWorker || isFetchingWorker,
          table: true,
        })}
      >
        <DataTable
          isLoading={isLoadingWorker || isFetchingWorker}
          headers={headersWorker}
          content={workerList() ?? []}
        />
        <DataTablePagination
          page={pageWorker}
          totalItems={workers?.count ?? 0}
          setPage={setPageWorker}
        />
      </div>
    </>
  );
};

export default Repair;